var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounCalendar4692017(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27.014,
    viewBox: "0 0 27 27.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-calendar-4692017",
    d: "M121.844,31.587h-2.721V30.075a.907.907,0,1,0-1.814,0v1.511h-4.233V30.075a.907.907,0,1,0-1.814,0v1.511H107.03V30.075a.907.907,0,1,0-1.814,0v1.511H102.5a3.328,3.328,0,0,0-3.325,3.326v16.93a3.328,3.328,0,0,0,3.325,3.325h19.349a3.328,3.328,0,0,0,3.325-3.325V34.912a3.328,3.328,0,0,0-3.325-3.326ZM102.5,33.4h2.721v1.512a.907.907,0,1,0,1.814,0V33.4h4.233v1.512a.907.907,0,1,0,1.814,0V33.4h4.233v1.512a.907.907,0,1,0,1.814,0V33.4h2.721a1.514,1.514,0,0,1,1.511,1.512v3.93H100.984v-3.93A1.514,1.514,0,0,1,102.5,33.4Zm19.349,19.953H102.5a1.514,1.514,0,0,1-1.511-1.511V40.656h22.372V51.843a1.514,1.514,0,0,1-1.511,1.511Z",
    transform: "translate(-98.67 -28.654)",
    stroke: "#000001",
    strokeWidth: 1,
    opacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounCalendar4692017);
export default __webpack_public_path__ + "static/media/noun-calendar-4692017.eb15588a16c55701123e32b6203c1fb5.svg";
export { ForwardRef as ReactComponent };